import Errors from "./Errors";

export default class {

  constructor(axiosInstance, {fields, url, url_get, url_put, url_post, url_delete, loading, name}, success, failure) {

    this.axiosInstance = axiosInstance;
    this.success = success;
    this.failure = failure;
    this.urls = {};
    (typeof (url_get) !== 'undefined') ? this.urls['get'] = url_get : this.urls['get'] = url;
    (typeof (url_post) !== 'undefined') ? this.urls['post'] = url_post : this.urls['post'] = url;
    (typeof (url_put) !== 'undefined') ? this.urls['put'] = url_put : this.urls['put'] = url;
    (typeof (url_delete) !== 'undefined') ? this.urls['delete'] = url_delete : this.urls['delete'] = url;
    this.fields = {};
    this.constructors = {};
    this.baseFieldAttrs = {
      default: null,
      name: null,
      description: null,
      type: 'string',
      component: null,
      options: {}
    };
    this.initFields(fields);
    this.errors = new Errors();
    if (loading) {
      this.loading = true;
    }
    this.processing = false;
    this.name = name
  }

  /**
   * helper to build the initial fields, description and names objects
   * @param fields
   */
  initFields(fields) {
    for (const [key, val] of Object.entries(fields)) {

      let base = this.constructors[key] = {...this.baseFieldAttrs};
      base.name = (val['name']) ? val['name'] : key;

      // if the field data is an object, run through it
      if (typeof val === 'object') {

        // if there's a default use this as the field value
        this.fields[key] = (val['default']) ? val['default'] : '';

        if (val['default']) base.default = val['default'];
        if (val['description']) base.description = val['description'];
        if (val['options']) base.options = val['options'];
        if (val['type']) base.type = val['type'];
        if (val['component']) base.component = val['component'];

      } else if (typeof val === 'string') {

        // if the field is initiated as a string, default to that value
        this.fields[key] = val;
      } else if (typeof val === 'boolean') {
        this.fields[key] = val;
        base.type = 'boolean';
      }
    }
  }

  // Fetch all relevant data for the form.
  data() {
    return this.fields;
  }

  // Reset the form fields.
  reset() {
    for (let field in this.fields) {
      this.fields[field] = '';
    }
    this.errors.clear();
  }


  post() {
    return this.submit('post', this.urls['post']);
  }

  put() {
    return this.submit('put', this.urls['put']);
  }

  get() {
    this.loading = true;
    return this.axiosInstance.get(this.urls['get'])
      .then(res => {
        return res.data
      })
      .then(res => {
        let response = res;
        if (response.data && response.data.attributes) {
          response = response.data.attributes
        }
        for (let prop in response) {
          if (this.fields.hasOwnProperty(prop)) {
            if (response[prop] !== null) {
              this.fields[prop] = response[prop]
            }
          }
        }
        this.loading = false;
        return res;
      })
  }

  destroy() {
    return this.submit('delete', this.urls['delete']);
  }

  submit(requestType, url) {
    this.errors.clear();
    if (this.processing === true) return;
    this.processing = true;
    return new Promise((resolve, reject) => {
      this.axiosInstance[requestType](url, this.data())
        .then(res => {
          // Callback handling for success
          this.processing = false;
          this.success(res);
          resolve(res);
        })
        .catch(error => {
          // Callback handling for failure
          this.processing = false;
          this.failure(error);
          if (error.response.status === 422) {
            this.onFail(error.response.data.errors);
          }
          reject(error)
        });
    });
  }


  /**
   * Handle a failed form submission.
   *
   * @param {object} errors
   */
  onFail(errors) {
    this.errors.record(errors);
  }
}
